import React, { Component } from 'react';
import BlogBanner from './BlogBanner';
import BlogPost from './BlogPost';
import { FaFacebookF, FaArrowLeft, FaArrowRight, FaSearch, FaTwitter, FaDribbble, FaBehance } from 'react-icons/fa';

class BlogPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<main>
				<BlogBanner />
				<div className="main-body mt-50 mb-50">
					<div className="container">
						<div className="row">
							<div className="offset-lg-1 col-lg-10 col-md-12 post-list">
								<BlogPost />

								<nav className="blog-pagination justify-content-center d-flex mt-30">
									<ul className="pagination">
										<li className="page-item">
											<a href="/blog-details" className="page-link" aria-label="Previous">
												<span aria-hidden="true">
													<FaArrowLeft />
												</span>
											</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">01</a>
										</li>
										<li className="page-item active">
											<a href="/" className="page-link">02</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">03</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">04</a>
										</li>
										<li className="page-item">
											<a href="/" className="page-link">09</a>
										</li>
										<li className="page-item">
											<a href="/blog-details" className="page-link" aria-label="Next">
												<span aria-hidden="true">
													<FaArrowRight />
												</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</main>
		);
	}
}

export default BlogPage;
